/**
 * The service-folder note a connect probe's data verdict leaves in the Object Explorer (RBAC fix 2026-09-25; review
 * 2026-09-25 MINOR 6; e2e audit G6): "no data access" when every read the probe made was refused, "partial data
 * access" when some checked items were readable — never a blanket denial then — with the verdict's own sentence as
 * the tooltip, so a SAS names its letters and only an Entra identity (the verdict carries `role`) gets role advice.
 */
import type { StorageDataAccessVerdict } from '../../../types/azureStorage';
import type { StorageNodeMetadata } from './nodeTypes';

export function dataAccessNoteOf(verdict: StorageDataAccessVerdict | undefined): StorageNodeMetadata['dataAccessNote'] {
  // UI review F7: refused on every item checked while more were not checked — access to those is unknown.
  if (verdict?.state === 'denied') return { badge: verdict.unchecked ? 'data access unknown' : 'no data access', detail: verdict.detail, ...(verdict.role ? { role: verdict.role } : {}) };
  if (verdict?.state === 'partial') return { badge: 'partial data access', detail: verdict.detail, role: verdict.role };
  return undefined;
}
